import React from "react";
import ReviewLeaderboardStoreView from "./ReviewLeaderboardStoreView";
import { setTokenApiClient } from "../../../api/axiosClient";
import { useLocation } from "react-router-dom";
import LogoRay from "../../../components/login/RAY_transparent_logo.png"


const ReviewLeaderboardEmployeeScreen = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const storeId = searchParams.get('storeId');
    const storeName = searchParams.get('storeName');
    const ssoToken = searchParams.get('sso');

    setTokenApiClient(ssoToken, false);
    return (
        <div style={{ width: '100%', height: '100%', backgroundColor: 'white' }}>
            <ReviewLeaderboardStoreView
                storeId={storeId}
                storeName={storeName}
                employeeView={true}
                showPeriodSelector={false}
                showEmployeeAdminButton={false}
            />
            <div className="powered-by" style={{ position: 'fixed', bottom: '20px', right: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>Powered by</span>{" "}
                <img
                    alt="ray-logo"
                    width={50}
                    src={LogoRay}
                ></img>
            </div>
        </div>
    );
    // return <div>Review Leaderboard Employee Screen</div>
}

export default ReviewLeaderboardEmployeeScreen;